import { 
  WAIT_INIT_ACCOUNTS, QUERY_ACCOUNTS, QUERY_ACCOUNTS_SUCCESS, QUERY_ACCOUNTS_FAIL, DELETE_ACCOUNT, DELETE_ACCOUNT_SUCCESS, DELETE_ACCOUNT_FAIL
} from '../actions/account/index';

import { 
  DELETE_CLOUD_ACCOUNT_SUCCESS
} from '../actions/cloud-account/index';

const doAction = (state, action) => {
  switch (action.type) {
    case WAIT_INIT_ACCOUNTS:
      return {
        ...state,
        status: WAIT_INIT_ACCOUNTS,
        accounts: [],
        errMsg: null,
        loading: true
      }
    case QUERY_ACCOUNTS:
      return {
        ...state,
        status: QUERY_ACCOUNTS,
        accounts: [],
        errMsg: null,
        loading: true
      }
    case QUERY_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: action.params.accounts,
        status: QUERY_ACCOUNTS_SUCCESS,
        accountDetail: {
          loading: true
        },
        loading: false
      }
    case QUERY_ACCOUNTS_FAIL:
      return {
        ...state,
        accounts: [],
        errMsg: action.params.errMsg,
        status: QUERY_ACCOUNTS_FAIL,
        loading: false
      }
    case DELETE_ACCOUNT:
      return {
        ...state,
        status: DELETE_ACCOUNT,        
        loading: true
      }
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        status: DELETE_ACCOUNT_SUCCESS,
        accounts: action.params.accounts,
        loading: false
      }
    case DELETE_ACCOUNT_FAIL:
      return {
        ...state,
        status: DELETE_ACCOUNT_FAIL,
        errMsg: action.params.errMsg,
        loading: false
      }
    case DELETE_CLOUD_ACCOUNT_SUCCESS:
      return {
        ...state,
        status: DELETE_CLOUD_ACCOUNT_SUCCESS,
        accounts: [],
        loading: false
      }
  default:
    return state;
  }
}

const accountReducers = (state = {
  accounts: [],
  errMsg: null,
  status: WAIT_INIT_ACCOUNTS,
  loading: false
}, action) => {
  switch (action.type) {
    default:
      return doAction(state, action);
  }
}

export default accountReducers;